<script lang="ts">
import { defineComponent, computed } from 'vue'
import Sidebar from './Sidebar.vue'
import { appSidebarDesktopCSS } from '@/models/'
import type { ISidebarProps } from './sidebar.interface'
import type { INavigationItem } from '@/models'
defineComponent({
  name: 'SidebarDesktop',
})
</script>

<script setup lang="ts">
const props = defineProps<ISidebarProps>()

const emits = defineEmits<{
  (e: 'menuItemClicked', value: INavigationItem): any
  (e: 'expandOrCollapse', value: INavigationItem): any
  (e: 'toggleSidebarCollapsed'): any
}>()

const onExpandItemClick = (item: INavigationItem) => {
  emits('expandOrCollapse', item)
}

const onMenuItemClicked = (item: INavigationItem) => {
  emits('menuItemClicked', item)
}

const onToggleDesktopSidebarCollapsed = () => {
  emits('toggleSidebarCollapsed')
}

const wrapperCssClass = computed(() => {
  return appSidebarDesktopCSS.wrapperCssClass(props.isCollapsed)
})
</script>

<template>
  <div :class="wrapperCssClass" aria-label="Sidebar">
    <Sidebar
      v-bind="props"
      @expandOrCollapse="onExpandItemClick"
      @menuItemClicked="onMenuItemClicked"
      @toggleSidebarCollapsed="onToggleDesktopSidebarCollapsed"
    />
  </div>
</template>
